import React from 'react'
import SarasCheckBox from '../../input/checkbox/SarasCheckBox2'
import SarasSwitchButton from '../../input/buttons/switchButton/SarasSwitchButton2'
import * as fn from "../../../helper/uiFunctions";

const FormCheckbox = (props) => {
    const { formObject, action, rowKey, headerKey, text, id, roClass } = props;

    const [cssClass,setCssClass] = React.useState('')

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "0");

    const onClick = (e, value) => {
        // console.log("form input changed", e, action, value);
        if (action.InputType === 'switch')
            setClassNameforSwitch(value)
        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, value);

        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
    }

    const setClassNameforSwitch = (isChecked) => {
        if(!isChecked && viewData.dataList && viewData.dataList.colCssClass)
            setCssClass(viewData.dataList.colCssClass)
        else if(isChecked){
            let cssclassName = fn.compareNumber(isChecked, 1) ? "uiDayWorking" : "uiDayHoliday";
            setCssClass(cssclassName)
        }
        else{
            let cssclassName = fn.compareNumber(viewData.val, 1) ? "uiDayWorking" : "uiDayHoliday";
            setCssClass(cssclassName)
        }
    }

    const getValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        return value;
    }

    if(viewData && fn.compareNumber(hide, 0)){
        if(fn.compareNumber(isRO, 1)) {
            if (action.InputType === 'onOff') {
                return (
                    <span className={roClass}>{getValue()}</span>
                )
            }
            else if (action.InputType === 'switch') {
                return (
                    <>
                        {viewData.dataList.valS || text }<span>: </span>
                        <span className={roClass}>{getValue()}</span>
                    </>
                )
            }
        }
        else if (action.InputType === 'onOff') {
            return (
                <SarasSwitchButton value={viewData.val} onClick={onClick} />
            )
        }
        else if (action.InputType === 'switch') {
            if(!cssClass)setClassNameforSwitch();

            return (
                <label htmlFor={id} className={`switchOnOffLabel ${cssClass}`}>{viewData.dataList.valS || text }
                    <SarasCheckBox id={id} className="switchOnOff" value={viewData.val} onClick={onClick} />
                </label>
            )
        }
        else {
            return (
                <SarasCheckBox value={viewData.val} onClick={onClick} />
            )
        }
    }

    return (null);
}

export default FormCheckbox